import React from 'react';
import Card from '@mui/material/Card';
import Icon from '@mui/material/Icon';
import { useLocation } from 'react-router-dom';
import { alpha, useTheme as useMuiTheme } from '@mui/material/styles';

import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';

import { CompanyReportsTab } from './tabs/CompanyReportsTab';
import { MemberReportsTab } from './tabs/MemberReportsTab';

function PageHero({ title, subtitle, icon }) {
  const theme = useMuiTheme();
  return (
    <Card
      sx={{
        p: { xs: 1.6, md: 2.1 },
        borderRadius: '26px',
        border: 'none',
        boxShadow: `0 22px 48px ${alpha(theme.palette.common.black, 0.08)}`,
        backgroundImage: `linear-gradient(135deg, ${alpha('#F59E0B', 0.12)}, ${alpha(
          '#0EA5E9',
          0.1
        )})`,
      }}
    >
      <MDBox display="flex" alignItems="center" gap={1.2}>
        <MDBox
          sx={{
            width: 54,
            height: 54,
            borderRadius: '18px',
            display: 'grid',
            placeItems: 'center',
            bgcolor: alpha(theme.palette.background.paper, 0.72),
          }}
        >
          <Icon sx={{ fontSize: 26 }}>{icon}</Icon>
        </MDBox>
        <MDBox>
          <MDTypography variant="h4" fontWeight="bold">
            {title}
          </MDTypography>
          <MDTypography variant="button" sx={{ color: 'text.secondary' }}>
            {subtitle}
          </MDTypography>
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default function PilatesReportsPage() {
  const location = useLocation();
  const isMemberReports = (location.pathname || '').endsWith('/reports/members');

  return (
    <MDBox sx={{ display: 'grid', gap: 1.5 }}>
      <PageHero
        icon={isMemberReports ? 'groups' : 'insights'}
        title={isMemberReports ? 'Üye Raporları' : 'Şirket Raporları'}
        subtitle={
          isMemberReports
            ? 'Operasyon odaklı üye görünümü, paket akışı ve hızlı modal aksiyonları.'
            : 'Genel finans, performans ve işletme özetleri.'
        }
      />

      {isMemberReports ? <MemberReportsTab /> : <CompanyReportsTab />}
    </MDBox>
  );
}
